import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];
let refreshing = null;
axios.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status !== 401 || !cfg || cfg._retry || NO_REFRESH.some((p) => cfg.url.includes(p))) throw error;
  cfg._retry = true;
  refreshing = refreshing || axios.post(`${API}/auth/refresh`).finally(() => { refreshing = null; });
  try { await refreshing; } catch { throw error; }
  return axios(cfg);
});

export function apiError(e, fallback = "Qualcosa è andato storto. Riprova.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace(/^Value error, /, "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}

const data = (p) => p.then((r) => r.data);
export const authApi = {
  me: () => data(axios.get(`${API}/auth/me`)),
  login: (body) => data(axios.post(`${API}/auth/login`, body)),
  register: (body) => data(axios.post(`${API}/auth/register`, body)),
  logout: () => data(axios.post(`${API}/auth/logout`)),
  forgot: (email, lang) => data(axios.post(`${API}/auth/forgot-password`, { email, lang })),
  reset: (token, password) => data(axios.post(`${API}/auth/reset-password`, { token, password })),
};
export const translateTrip = (id, lang) => data(axios.post(`${API}/trips/${id}/translate`, { lang }));
export const emailTrip = (id, body) => data(axios.post(`${API}/trips/${id}/email`, body));
export const trackEmailClick = (id) => axios.post(`${API}/trips/${id}/events`, { type: "email_click" }).catch(() => null);
export const trackEvent = (id, type) => axios.post(`${API}/trips/${id}/events`, { type }).catch(() => null);
export const goUrl = (tripId, target, u, dates) => {
  const q = new URLSearchParams();
  if (u) q.set("u", u);
  if (dates?.a && dates?.r) { q.set("a", dates.a); q.set("r", dates.r); }
  const s = q.toString();
  return `${API}/go/${tripId}/${target}${s ? `?${s}` : ""}`;
};
export const getTripPartners = (id) => data(axios.get(`${API}/trips/${id}/partners`));
export const pdfAccess = (id) => data(axios.get(`${API}/trips/${id}/pdf-access`));
export const pdfUnlock = (id) => data(axios.post(`${API}/trips/${id}/pdf-unlock`));
export const startCheckout = (plan, tripId, currency = "eur") =>
  data(axios.post(`${API}/payments/checkout`, { plan, trip_id: tripId || null, origin_url: window.location.origin, currency }));
export const paymentStatus = (sid) => data(axios.get(`${API}/payments/status/${sid}`));
export const myTrips = () => data(axios.get(`${API}/me/trips`));
export const saveTrip = (id) => data(axios.post(`${API}/trips/${id}/save`));
export const deleteTrip = (id) => data(axios.delete(`${API}/me/trips/${id}`));
export const billingStatus = () => data(axios.get(`${API}/billing/status`));
export const cancelSubscription = () => data(axios.post(`${API}/billing/cancel`));
export const adminApi = {
  stats: () => data(axios.get(`${API}/admin/stats`)),
  trips: () => data(axios.get(`${API}/admin/trips`)),
  payments: () => data(axios.get(`${API}/admin/payments`)),
  users: () => data(axios.get(`${API}/admin/users`)),
  subscribers: () => data(axios.get(`${API}/admin/subscribers`)),
  funnel: (period) => data(axios.get(`${API}/admin/funnel`, { params: { period } })),
  partners: () => data(axios.get(`${API}/admin/partners`)),
  createPartner: (body) => data(axios.post(`${API}/admin/partners`, body)),
  updatePartner: (id, body) => data(axios.put(`${API}/admin/partners/${id}`, body)),
  deletePartner: (id) => data(axios.delete(`${API}/admin/partners/${id}`)),
  affiliateClicks: (period) => data(axios.get(`${API}/admin/affiliate-clicks`, { params: { period } })),
  events: (period) => data(axios.get(`${API}/admin/events`, { params: { period } })),
};

export const startTrip = (payload) =>
  axios.post(`${API}/trips/generate`, payload).then((r) => r.data)
    .catch(() => { throw new Error("Richiesta non valida. Controlla i dati inseriti."); });

export const getTrip = (id) => axios.get(`${API}/trips/${id}`).then((r) => r.data);

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function waitForTrip(id, onProgress, isCancelled = () => false) {
  let failures = 0;
  while (!isCancelled()) {
    try {
      const t = await getTrip(id);
      failures = 0;
      if (t.status === "ready") return t;
      if (t.status === "error") throw Object.assign(new Error(t.error), { final: true });
      onProgress(t.progress || 0);
    } catch (e) {
      if (e.final || ++failures > 5) throw new Error(e.final ? e.message : "Connessione interrotta. Riprova.");
    }
    await sleep(2500);
  }
  return null;
}

export const sendFeedback = (id, value) =>
  axios.post(`${API}/trips/${id}/feedback`, { value }).then((r) => r.data);
